import { dispatchFBEvent, ecommerce } from '@uds/tagmg';
import { selectors as productSelectors } from '@uds/product';
import { GetProductData } from 'core/cta';
import { getLanguageCookie } from 'domain/selectors/common';
import { dispatchGA4Event } from 'infrastructure/ga4';

const sendProductOnAddToBasket = ({
  productId,
  list,
  getProductData,
  currency,
  brandId,
  term,
}: {
  list: string;
  productId?: string | null;
  getProductData: GetProductData;
  currency: string;
  brandId: string;
  term?: number | null;
}) => {
  const locale = getLanguageCookie();
  if (!productId) {
    return;
  }
  return getProductData({
    skuId: productId,
    locale,
  }).then((product) => {
    let price = 0;
    // in case we ever get a malformed product, getPrice would throw an error
    try {
      price = productSelectors.getPrice({
        product,
        includeTax: true,
      });
    } catch (e) {
      return;
    }
    if (product == null) return;
    const id = product.id;
    const name = product.name;
    const category = product.categoryName;
    dispatchFBEvent('AddToCart', {
      // eslint-disable-next-line camelcase
      content_ids: [id],
      // eslint-disable-next-line camelcase
      content_name: name,
      value: price,
      quantity: 1,
      // eslint-disable-next-line camelcase
      content_type: category,
      currency: currency,
    });
    ecommerce([
      [
        'addProduct',
        {
          id: `${id}`,
          name,
          price,
        },
      ],
      [
        'setAction',
        'add',
        {
          list,
        },
      ],
    ]);
    // Send GA4 ecommerce data
    const items = [{
      'item_name': product.name,
      'item_id': product.id,
      'item_group_id': product.id,
      'item_brand': brandId,
      'item_category': product.categoryName,
      'item_variant': `${product.name} ${term ?? product.defaultPrice?.term}`,
      'currency': currency,
      'price': price,
      'quantity': 1,
    }];
    dispatchGA4Event('add_to_cart', { items });
  });
};

export default sendProductOnAddToBasket;
